import classNames from "classnames";
import {useState} from "react";
import {FiLogOut} from "react-icons/fi";
import {NavLink} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Dropdown} from "@/components/dropdown/Dropdown";
import {Icon} from "@/components/icon/Icon.tsx";
import {NavBarProfileButtonContent} from "@/components/navBar/subComponents/NavbarProfileButtonContent/NavBarProfileButtonContent.tsx";
import {logoutZendeskMessaging} from "@/lib/integrations/zendesk.ts";
import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";
import {displayForUserAccessLevel} from "@/lib/types/accounts.ts";

import styles from "./NavBarProfile.module.scss";

export const NavBarProfile = () => {
  const {user} = useCurrentUserContext();
  const [show, setShow] = useState(false);

  if (!user) return null;

  return (
    <div className="mt-auto">
      <Dropdown show={show} onToggle={setShow} drop={"end"}>
        <Dropdown.Toggle
          variant="profileNavButton"
          className={classNames("w-100", {active: show})}
          data-testid="Profile Button"
        >
          <NavBarProfileButtonContent user={user} show={show} />
        </Dropdown.Toggle>
        <Dropdown.Menu className={classNames(styles.popupMenu, "p-3")}>
          <div className={styles.menuHeader}>
            <div className="pulseTextBodySmallBold">
              {user.first_name} {user.last_name || ""}
            </div>
            <div className="pt-1 pulseTextBodySmall pulse-color-gray-700">{displayForUserAccessLevel(user)}</div>
          </div>
          <Dropdown.Divider className="my-2" />
          {user?.has_admin_access && (
            <Dropdown.Item
              className={styles.menuEntry}
              as={NavLink}
              to="/accounts/account-details"
              data-testid="Account Details"
            >{`${user?.account.is_subaccount ? "Subaccount" : "Account"} Details`}</Dropdown.Item>
          )}
          <Dropdown.Item className={styles.menuEntry} as={NavLink} to="/accounts/profile" data-testid="User Profile">
            User Profile
          </Dropdown.Item>
          <Dropdown.Item
            className={styles.menuEntry}
            href="https://support.uptime.com/hc/en-us/articles/360001311220-Getting-Started-With-Uptime-com"
            target={"_blank"}
          >
            Getting Started
          </Dropdown.Item>
          <Dropdown.Item className={styles.menuEntry} href="https://support.uptime.com" target={"_blank"}>
            Documentation
          </Dropdown.Item>
          <Dropdown.Divider className="my-2" />
          <Dropdown.Item
            className={classNames(styles.menuEntry, styles.logout)}
            href={`${URL_ORIGINAL_WEBSITE}/accounts/logout`}
            data-testid="Log out"
            onClick={logoutZendeskMessaging}
          >
            <Icon size={"navIcon"} className="me-1" icon={FiLogOut} />
            Log out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
